import { useState, useEffect } from "react";
import { Drawer } from "antd";
import Colors from "assets/Colors";
import HamburgerIcon from "components/icons/HamburgerIcon";
import CloseIcon from "components/icons/CloseIcon";
import ArrowBackIcon from "components/icons/ArrowBackIcon";
import LocationUrl from "components/common/LocationUrl";
import StoreSelector from "containers/SideBarTopMenuHOC/StoreSelector";
import Profile from "containers/SideBarTopMenuHOC/Profile";
import LanguageSelector from "containers/SideBarTopMenuHOC/LanguageSelector";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MainMenu from "./MainMenu";
import SecondaryMenu from "./SecondaryMenu";
import s from "./styles";

export const INFO_SUBMENU = "infoSubMenu";
export const CONFIG_SUBMENU = "configSubMenu";
export const INVENTORY_SUBMENU = "inventorySubMenu";
export const WORKERS_SUBMENU = "workersSubMenu";

function BottomDrawer({ component, noShowBottomDrawer }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  function initialValueMenu() {
    if (location.pathname.includes("/reports/")) {
      return INFO_SUBMENU;
    }
    if (location.pathname.includes("/settings/")) {
      return CONFIG_SUBMENU;
    }
    if (location.pathname.includes("/inventory/")) {
      return INVENTORY_SUBMENU;
    }
    return "main";
  }

  function closeDrawer() {
    setOpen(false);
    setMenu(initialValueMenu());
  }

  const [menu, setMenu] = useState(initialValueMenu());

  let menuName = "";
  if (menu === INFO_SUBMENU) {
    menuName = t("containers.SideBarTopMenuHOC.BottomDrawer.informs");
  } else if (menu === CONFIG_SUBMENU) {
    menuName = t("containers.SideBarTopMenuHOC.BottomDrawer.configuration");
  } else if (menu === INVENTORY_SUBMENU) {
    menuName = t("containers.SideBarTopMenuHOC.BottomDrawer.inventory");
  }

  useEffect(() => {
    document.getElementsByTagName("body")[0].style.overflow = open
      ? "hidden"
      : null;

    return () => {
      document.getElementsByTagName("body")[0].style.overflow = null;
    };
  }, [open]);

  const header = (
    <s.HeaderWrapper onClick={() => !open && setOpen(true)}>
      <s.HeaderContentWrapper>
        <s.MenuIconWrapper
          onClick={() =>
            open &&
            ((menu === "main" && closeDrawer()) ||
              (menu !== "main" && setMenu("main")))
          }
        >
          {open && menu === "main" && (
            <CloseIcon size={18} color={Colors.text_primary} />
          )}
          {open && menu !== "main" && (
            <ArrowBackIcon size={24} color={Colors.text_primary} />
          )}
          {!open && <HamburgerIcon color={Colors.text_primary} />}
        </s.MenuIconWrapper>
        <s.SectionTitle>{menuName || <LocationUrl />}</s.SectionTitle>
      </s.HeaderContentWrapper>
      <s.HeaderContentWrapper>
        {open && (
          <>
            <Profile />
            <LanguageSelector style={{ marginLeft: "30px" }} />
          </>
        )}
      </s.HeaderContentWrapper>
    </s.HeaderWrapper>
  );

  const infoSubMenus = (
    <SecondaryMenu
      items={[
        {
          path: "/reports/sales",
          name: t("containers.SideBarTopMenuHOC.BottomDrawer.sells"),
        },
        {
          path: "/reports/payment_methods",
          name: t("containers.SideBarTopMenuHOC.BottomDrawer.pays"),
        },
        {
          path: "/reports/taxes",
          name: t("containers.SideBarTopMenuHOC.BottomDrawer.taxes"),
        },
        {
          path: "/reports/categories",
          name: t("containers.SideBarTopMenuHOC.BottomDrawer.categories"),
        },
        {
          path: "/reports/items",
          name: t("containers.SideBarTopMenuHOC.BottomDrawer.items"),
        },
        {
          path: "/reports/customers",
          name: t("containers.SideBarTopMenuHOC.BottomDrawer.customers"),
        },
        {
          path: "/reports/employee",
          name: t("containers.SideBarTopMenuHOC.BottomDrawer.employees"),
        },
      ]}
    />
  );

  const configSubMenus = (
    <SecondaryMenu
      items={[
        {
          path: "/settings/general",
          name: t("containers.SideBarTopMenuHOC.BottomDrawer.generalInfo"),
        },
        {
          path: "/settings/store",
          name: t("containers.SideBarTopMenuHOC.BottomDrawer.storeSettings"),
        },
        // {
        //   path: "/settings/openHours",
        //   name: t("containers.SideBarTopMenuHOC.BottomDrawer.storeHours"),
        // },
        {
          path: "/settings/owner",
          name: t("containers.SideBarTopMenuHOC.BottomDrawer.holderData"),
        },
      ]}
    />
  );

  const workersSubMenus = (
    <SecondaryMenu
      items={[
        {
          path: "/employees/list",
          name: t("containers.SideBarTopMenuHOC.BottomDrawer.list"),
        },
        {
          path: "/employees/schedules",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.schedules"),
        },
      ]}
    />
  );

  const inventorySubMenus = (
    <SecondaryMenu
      items={[
        {
          path: "/inventory/items",
          name: t("containers.SideBarTopMenuHOC.BottomDrawer.articles"),
        },
        {
          path: "/inventory/categories",
          name: t(
            "containers.SideBarTopMenuHOC.BottomDrawer.categoriesSubMenu"
          ),
        },
        {
          path: "/inventory/variants",
          name: t("containers.SideBarTopMenuHOC.BottomDrawer.variants"),
        },
        {
          path: "/inventory/modifiers",
          name: t("containers.SideBarTopMenuHOC.BottomDrawer.modifiers"),
        },
        {
          path: "/inventory/priceList",
          name: t("containers.SideBarTopMenuHOC.BottomDrawer.priceList"),
        },
      ]}
    />
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        overflow: "visible",
        // height: "100vh",
      }}
    >
      <div>{component}</div>
      <div>
        <Drawer
          style={{ visibility: noShowBottomDrawer && "hidden" }}
          placement="bottom"
          height={open ? "90vh" : "auto"}
          closable={false}
          visible
          bodyStyle={{ padding: 0 }}
          onClose={() => {
            open && closeDrawer();
          }}
          mask={open}
          contentWrapperStyle={
            open
              ? {
                boxShadow: "none",
                borderTop: `1px solid ${Colors.line_separator}`,
              }
              : {
                height: "auto",
                boxShadow: "none",
                borderTop: `1px solid ${Colors.line_separator}`,
              }
          }
          id="BottomDrawer"
        >
          {header}
          {open && (
            <s.BodyWrapper>
              <StoreSelector />
              {menu === "main" && (
                <MainMenu setSubMenu={(menu) => setMenu(menu)} />
              )}
              {menu === INFO_SUBMENU && infoSubMenus}
              {menu === CONFIG_SUBMENU && configSubMenus}
              {menu === INVENTORY_SUBMENU && inventorySubMenus}
              {menu === WORKERS_SUBMENU && workersSubMenus}
            </s.BodyWrapper>
          )}
        </Drawer>
      </div>
      <div style={{ visibility: "hidden" }}>{header}</div>
    </div>
  );
}

export default BottomDrawer;
